<template>
  <div class="content">
    <div class="banner">
      <img :src="getConfig.banner" alt="banner" />
    </div>
    <PageHeader v-if="!isHome" title="返回" @back="back" />
    <div class="topTitle">
      <h2>{{ getConfig.name || "激活系统" }}</h2>
      <p>{{ getConfig.nameEn || "Activation System" }}</p>
    </div>
    <router-view />
    <div class="footer"><img :src="getConfig.footer" alt="" /></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageHeader from "@/components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      isHome: true,
    };
  },
  computed: {
    ...mapGetters("activationStore", ["getConfig"]),
  },
  methods: {
    back() {
      if (!this.isHome) {
        localStorage.clear();
        this.$router.back();
      }
    },
  },
};
</script>
